import i18n from '@/plugins/i18n'
import * as types from '@/store/mutation-types'
import { isPast } from 'date-fns'
import { store } from '@/store'
//import router from '@/router'

export const formatErrorMessages = (translationParent, msg) => {
  const errorArray = []
  // Check for error msgs
  if (msg !== null) {
    const json = JSON.parse(JSON.stringify(msg))
    // If error message is an array, then we have mutiple errors
    if (Array.isArray(json)) {
      json.map(error => {
        errorArray.push(i18n.t(`${translationParent}.${error.msg}`))
      })
    } else {
      // Single error
      errorArray.push(i18n.t(`${translationParent}.${msg}`))
    }
    return errorArray
  }
  // all good, return null
  return null
}

export const buildPayloadPagination = (pagination, searchArg = {}) => {
  const { eventId, page, itemsPerPage } = pagination

  const sort = Array.isArray(pagination.sortBy)
    ? pagination.sortBy[0]
    : pagination.sortBy

  const order = Array.isArray(pagination.sortDesc)
    ? (pagination.sortDesc[0] ? -1 : 1)
    : (pagination.sortDesc ? -1 : 1)

  // aceita tanto { search: {...} } quanto {...}
  const search = searchArg && searchArg.search ? searchArg.search : searchArg

  const base = {
    eventId,
    sort,
    order,
    page,
    limit: itemsPerPage
  }

  // caminho "withdraws"
  if (search && search.status) {
    const query = {
      ...base,
      status: search.status,
      key: search.searchTerm
    }
    if (search.start) query.start = search.start
    if (search.end) query.end = search.end
    return query
  }

  // caminho genérico com fields/query
  if (search && Object.keys(search).length > 0) {
    return {
      ...base,
      filter: search.query,
      fields: search.fields,
      query: search
    }
  }

  // sem filtros
  return base
}
// export const buildPayloadPagination = (pagination, search) => {

//   const { eventId, sortBy, page, itemsPerPage } = pagination
//   let { descending } = pagination.sortDesc[0]
//   descending = pagination.sortDesc[0] ? -1 : 1
//   let query = {}

//   if(search.status){ // campos para a busca de withdraws
//     query = {
//       eventId: eventId,
//       sort: sortBy,
//       order: descending,
//       page,
//       limit: itemsPerPage,
//       status: search.status,
//       key: search.searchTerm
//     }

//   }else if (Object.keys(search).length > 0 && search.status == null) { // If search and fields are defined

//     query = {
//       eventId: eventId,
//       sort: sortBy,
//       order: descending,
//       page,
//       limit: itemsPerPage,
//       filter: search.query,
//       fields: search.fields,
//       query: search,
//     }

//   } else {
//     // Pagination with no filters
//     query = {
//       eventId: eventId,
//       sort: sortBy,
//       order: descending,
//       page,
//       limit: itemsPerPage
//     }
//   }

//   return query
// }

// Catches error connection or any other error (checks if error.response exists)
export const handleError = (error, commit, reject) => {

  let errMsg = ''
  // Resets errors in store
  commit(types.SHOW_BTN_LOADING, false)
  commit(types.SHOW_TOP_LOADING, false)
  commit(types.SHOW_CENTER_LOADING, false)
  commit(types.ERROR, null)

  // Checks if unauthorized
  if (error.response !== undefined && error.response.status === 401) {
    errMsg = error.response.data.errors.msg
    store.dispatch('userLogout')
  } else {
    // Any other error
    errMsg = error.response
      ? error.response.data.errors.msg
      : 'SERVER_TIMEOUT_CONNECTION_ERROR'
  }

  console.log('errMsg', errMsg)
  setTimeout(() => {
    return errMsg
      ? commit(types.ERROR, errMsg)
      : commit(types.SHOW_ERROR, false)
  }, 0)
  reject(error)
}

export const buildSuccess = (
  msg,
  commit,
  resolve,
  resolveParam = undefined
) => {
  commit(types.SHOW_BTN_LOADING, false)
  commit(types.SHOW_TOP_LOADING, false)
  commit(types.SHOW_CENTER_LOADING, false)
  commit(types.SUCCESS, null)
  setTimeout(() => {
    return msg ? commit(types.SUCCESS, msg) : commit(types.SHOW_SUCCESS, false)
  }, 0)
  commit(types.ERROR, null)
  resolve(resolveParam)
}

// Checks if tokenExpiration in localstorage date is past, if so then trigger an update
export const checkIfTokenNeedsRefresh = () => {
  //console.log('tokenExpiration: '+new Date(JSON.parse(window.localStorage.getItem('tokenExpiration')) * 1000))
  if (
    window.localStorage.getItem('token') !== null &&
    window.localStorage.getItem('tokenExpiration') !== null &&
    isPast(new Date(JSON.parse(window.localStorage.getItem('tokenExpiration')) * 1000))
  ) {
      //router.go()
      store.dispatch('refreshToken')
    }
}
